import { graphql } from '@prophecy/graphql-types/graphql';
import { ProjectContentCountFields, ProjectSqlContentCountFields } from './ProjectContentFields';
export const addSubscriberToProjectQuery = graphql(`
  mutation addSubscriberToProject($uid: String!, $teamId: String!) {
    addSubscriberToProject(uid: $uid, teamUID: $teamId)
  }
`);
export const removeSubscriberFromProjectQuery = graphql(`
  mutation removeSubscriberFromProject($uid: String!, $teamId: String!) {
    removeSubscriberFromProject(uid: $uid, teamUID: $teamId)
  }
`);
export const PotentialSubscribedTeamQuery = graphql(`
  query PotentialSubscribedTeamQuery($uid: String!) {
    Project(uid: $uid) {
      potentialSubscriberTeams {
        _id
        name
      }
    }
  }
`);
export const UserTeamsQuery = graphql(`
  query getUserTeams($uid: String!) {
    User(uid: $uid) {
      _id
      teams {
        _id
        name
        teamKind
        teamState
        admins {
          _id
        }
        productType
        createdBy
        workspaceAlias
        createdByFullName
        created
        verticalAppDefaults {
          fabricId
          fabricType
        }
      }
    }
  }
`);
/** The user's fabrics and the team each belongs to — what picking a workspace's own fabric needs. */
export const UserFabricTeamsQuery = graphql(`
  query getUserFabricTeams($uid: String!) {
    User(uid: $uid) {
      _id
      fabrics {
        _id
        name
        team {
          _id
        }
      }
    }
  }
`);
export const TeamAvailableProjectsQuery = graphql(`
  query TeamAvailableProjectsQuery($uid: String!, $language: BackEndCodeLanguage!, $sqlProviderType: String, $gitProviderType: GitProviderType) {
    Team(uid: $uid) {
      availableProjectDependencies(language: $language, sqlProviderType: $sqlProviderType, gitProviderType: $gitProviderType) {
        _id
        name
        description
        latestReleaseVersion
        readme
        publishedToPackageHub
        language,
        team {
          _id
          name
        }
        ${ProjectSqlContentCountFields}
        ${ProjectContentCountFields}
      }
    }
  }
`);
export const TeamAvailableDefaultDependenciesQuery = graphql(`
  query TeamAvailableDefaultDependenciesQuery(
    $uid: String!
    $language: BackEndCodeLanguage!
    $sqlProviderType: String
  ) {
    Team(uid: $uid) {
      availableDefaultDependencies(language: $language, sqlProviderType: $sqlProviderType) {
        _id
      }
    }
  }
`);
export const removeTeamMemberQuery = graphql(`
  mutation removeTeamMember($userId: String!, $uid: String!) {
    removeTeamMember(userUID: $userId, teamUID: $uid)
  }
`);
export const TeamWithAdminQuery = graphql(`
  query GqlQuery_PageTeam($uid: String!) {
    Team(uid: $uid) {
      _id
      name
      artefactID
      admins {
        _id
      }
      copilotEnabled
      copilotDataSamplingEnabled
      agentV4Enabled
      info: aspects(aspect: Info) {
        AspectName
        AspectValue
      }
      adminInfo: aspects(aspect: AdminInfo) {
        AspectName
        AspectValue
      }
    }
  }
`);
export const getTeamOrchestrationsQuery = graphql(`
  query TeamOrchestrationsQuery($uid: String!) {
    Team(uid: $uid) {
      defaultOrchestrationEndpoints
    }
  }
`);
